import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { selectEntitiesByFilters } from '../../../../../../store/views/entityView';
import endPointsSections from '../../../../../../store/models/endPointsSections';
import { eventsByDomainQuery } from '../../../../../../utils/entitiesFiltersUtils';
import DayClock from '../../../../../ui/DayClock/DayClock';
import iconsList from '../../../../../ui/icons/iconsList';
import classes from './MatriculationCounters.module.css';

const MatriculationCounters = ({ domainName }) => {
    const { texts } = useSelector(state => state.translate);
    const { domainName: paramsDomainName } = useParams();
    const currentDomainName = domainName || paramsDomainName;
    const matriculationsQuery = useMemo(() => eventsByDomainQuery(currentDomainName, endPointsSections.myMatriculationEvents), [currentDomainName]);
    const matriculations = useSelector((state) => selectEntitiesByFilters(state, matriculationsQuery));

    const moeMatriculation = useMemo(() => {
        const now = new Date();
        return matriculations
            .filter(m => m.providerName === "moecalendar" && new Date(m.date) > now)
            .sort((a, b) => new Date(a.date) - new Date(b.date))[0];
    }, [matriculations]);

    const bgtMatriculation = useMemo(() => {
        const now = new Date();
        return matriculations
            .filter(m => m.providerName === "bgt" && new Date(m.date) > now)
            .sort((a, b) => new Date(a.date) - new Date(b.date))[0];
    }, [matriculations]);

    if (!moeMatriculation && !bgtMatriculation) {
        return null;
    }

    return (
        <div className={classes.Counters}>
            {moeMatriculation &&
                <DayClock
                    label={texts.daysToMyMatriculation}
                    date={moeMatriculation?.date}
                    icon={iconsList.archiveBookIcon}
                />
            }
            {bgtMatriculation &&
                <DayClock
                    label={texts.daysToFlexibleMatriculation}
                    date={bgtMatriculation?.date}
                    icon={iconsList.archiveBookIcon}
                />
            }
        </div>
    );
};

export default MatriculationCounters;
